import React from 'react';
import PropTypes from 'prop-types';

export const WriterlyAuthLogo = ({ data }) => {
  return (
    <div className="writerly-logo flex justify-center">
      <img
        src={require(`../../assets/images/open-sidebar-logo-light.png`)}
        width={'156px'}
        height={'36px'}
      />
    </div>
  );
};

WriterlyAuthLogo.propTypes = {
  data: PropTypes.any,
};
